import { render, staticRenderFns } from "./BandejaComponenteV5.vue?vue&type=template&id=5eae4bd0&scoped=true"
import script from "./BandejaComponenteV5.vue?vue&type=script&lang=js"
export * from "./BandejaComponenteV5.vue?vue&type=script&lang=js"
import style0 from "./BandejaComponenteV5.vue?vue&type=style&index=0&id=5eae4bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eae4bd0",
  null
  
)

export default component.exports